module.exports = __webpack_public_path__ + "static/rajesh-rajput-y2MeW00BdBo-unsplash-635a62b01790a4312f72d56eb27b7cf8.jpg";